
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.2.6a.6.6 0 01.6-.6h3.6a.6.6 0 01.6.6v3.6a.6.6 0 11-1.2 0v-3h-3a.6.6 0 01-.6-.6zM0 .6A.6.6 0 01.6 0h3.6a.6.6 0 010 1.2h-3v3a.6.6 0 01-1.2 0V.6zM11.4 7.2a.6.6 0 01.6.6v3.6a.6.6 0 01-.6.6H7.8a.6.6 0 110-1.2h3v-3a.6.6 0 01.6-.6zM.6 7.2a.6.6 0 01.6.6v3h3a.6.6 0 110 1.2H.6a.6.6 0 01-.6-.6V7.8a.6.6 0 01.6-.6z","fill":"#333"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.824.176a.6.6 0 010 .848l-3.9 3.9a.6.6 0 11-.848-.848l3.9-3.9a.6.6 0 01.848 0zM4.924 7.076a.6.6 0 010 .848l-3.9 3.9a.6.6 0 11-.848-.848l3.9-3.9a.6.6 0 01.848 0z","fill":"#333"}})])
          )
        }
      }
    